(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('ProductLot', ProductLot);

    ProductLot.$inject = ['$resource', 'DateUtils'];

    function ProductLot ($resource, DateUtils) {
        var resourceUrl =  'api/product-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.registrationDate = DateUtils.convertLocalDateFromServer(data.registrationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.registrationDate = DateUtils.convertLocalDateToServer(data.registrationDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.registrationDate = DateUtils.convertLocalDateToServer(data.registrationDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
